import _slicedToArray from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { lookupProfile, NAME_LOOKUP_PATH } from '@stacks/auth';
import { BLOCKSTACK_DEFAULT_GAIA_HUB_URL, DoesNotExist, getGlobalObject, InvalidStateError, megabytesToBytes, PayloadTooLargeError, SignatureVerificationError, utf8ToBytes } from '@stacks/common';
import { eciesGetJsonStringLength, getPublicKeyFromPrivate, publicKeyToBtcAddress, signECDSA, verifyECDSA } from '@stacks/encryption';
import { createFetchFn } from '@stacks/network';
import { FileContentLoader } from './fileContentLoader';
import { connectToGaiaHub, deleteFromGaiaHub, getBlockstackErrorFromResponse, getBucketUrl, getFullReadUrl, uploadToGaiaHub } from './hub';
var SIGNATURE_FILE_SUFFIX = '.sig';
export var Storage =
/*#__PURE__*/
function () {
  function Storage(options) {
    _classCallCheck(this, Storage);

    this.userSession = options.userSession;
  }

  _createClass(Storage, [{
    key: "getFile",
    value: function () {
      var _getFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(path, options) {
        var defaults, opt, storedContents, decryptOpt, decryptionKey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                defaults = {
                  decrypt: true,
                  verify: false,
                  app: getGlobalObject('location', {
                    returnEmptyObject: true
                  }).origin
                };
                opt = Object.assign({}, defaults, options);

                if (!(opt.verify && !opt.decrypt)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", this.getFileSignedUnencrypted(path, opt));

              case 4:
                _context.next = 6;
                return this.getFileContents(path, opt.app, opt.username, opt.zoneFileLookupURL, !!opt.decrypt);

              case 6:
                storedContents = _context.sent;

                if (!(storedContents === null)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", storedContents);

              case 11:
                if (!(opt.decrypt && !opt.verify)) {
                  _context.next = 22;
                  break;
                }

                if (!(typeof storedContents !== 'string')) {
                  _context.next = 14;
                  break;
                }

                throw new Error('Expected to get back a string for the cipherText');

              case 14:
                if (!(typeof opt.decrypt === 'string')) {
                  _context.next = 19;
                  break;
                }

                decryptOpt = {
                  privateKey: opt.decrypt
                };
                return _context.abrupt("return", this.userSession.decryptContent(storedContents, decryptOpt));

              case 19:
                return _context.abrupt("return", this.userSession.decryptContent(storedContents));

              case 20:
                _context.next = 34;
                break;

              case 22:
                if (!(opt.decrypt && opt.verify)) {
                  _context.next = 29;
                  break;
                }

                if (!(typeof storedContents !== 'string')) {
                  _context.next = 25;
                  break;
                }

                throw new Error('Expected to get back a string for the cipherText');

              case 25:
                if (typeof opt.decrypt === 'string') {
                  decryptionKey = opt.decrypt;
                }

                return _context.abrupt("return", this.handleSignedEncryptedContents(path, storedContents, opt.app, decryptionKey, opt.username, opt.zoneFileLookupURL));

              case 29:
                if (!(!opt.verify && !opt.decrypt)) {
                  _context.next = 33;
                  break;
                }

                return _context.abrupt("return", storedContents);

              case 33:
                throw new Error('Should be unreachable.');

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFile(_x, _x2) {
        return _getFile.apply(this, arguments);
      }

      return getFile;
    }()
  }, {
    key: "getUserAppFileUrl",
    value: function () {
      var _getUserAppFileUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(path, username, appOrigin, zoneFileLookupURL) {
        var profile, bucketUrl, url, bucket;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return lookupProfile({
                  username: username,
                  zoneFileLookupURL: zoneFileLookupURL
                });

              case 2:
                profile = _context2.sent;

                if (profile.hasOwnProperty('apps')) {
                  if (profile.apps.hasOwnProperty(appOrigin)) {
                    url = profile.apps[appOrigin];
                    bucket = url.replace(/\/?(\?|#|$)/, '/$1');
                    bucketUrl = "".concat(bucket).concat(path);
                  }
                }

                return _context2.abrupt("return", bucketUrl);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getUserAppFileUrl(_x3, _x4, _x5, _x6) {
        return _getUserAppFileUrl.apply(this, arguments);
      }

      return getUserAppFileUrl;
    }()
  }, {
    key: "getGaiaAddress",
    value: function () {
      var _getGaiaAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(app, username, zoneFileLookupURL) {
        var opts, fileUrl, gaiaHubConfig, matches;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                opts = normalizeOptions(this.userSession, {
                  app: app,
                  username: username,
                  zoneFileLookupURL: zoneFileLookupURL
                });

                if (!username) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this.getUserAppFileUrl('/', opts.username, opts.app, opts.zoneFileLookupURL);

              case 4:
                fileUrl = _context3.sent;
                _context3.next = 13;
                break;

              case 7:
                _context3.next = 9;
                return this.getOrSetLocalGaiaHubConnection();

              case 9:
                gaiaHubConfig = _context3.sent;
                _context3.next = 12;
                return getFullReadUrl('/', gaiaHubConfig);

              case 12:
                fileUrl = _context3.sent;

              case 13:
                matches = fileUrl.match(/([13][a-km-zA-HJ-NP-Z0-9]{26,35})/);

                if (matches) {
                  _context3.next = 16;
                  break;
                }

                throw new Error('Failed to parse gaia address');

              case 16:
                return _context3.abrupt("return", matches[matches.length - 1]);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getGaiaAddress(_x7, _x8, _x9) {
        return _getGaiaAddress.apply(this, arguments);
      }

      return getGaiaAddress;
    }()
  }, {
    key: "getFileUrl",
    value: function () {
      var _getFileUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(path, options) {
        var opts, readUrl, gaiaHubConfig;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                opts = normalizeOptions(this.userSession, options);

                if (!opts.username) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return this.getUserAppFileUrl(path, opts.username, opts.app, opts.zoneFileLookupURL);

              case 4:
                readUrl = _context4.sent;
                _context4.next = 13;
                break;

              case 7:
                _context4.next = 9;
                return this.getOrSetLocalGaiaHubConnection();

              case 9:
                gaiaHubConfig = _context4.sent;
                _context4.next = 12;
                return getFullReadUrl(path, gaiaHubConfig);

              case 12:
                readUrl = _context4.sent;

              case 13:
                if (readUrl) {
                  _context4.next = 17;
                  break;
                }

                throw new Error('Missing readURL');

              case 17:
                return _context4.abrupt("return", readUrl);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFileUrl(_x10, _x11) {
        return _getFileUrl.apply(this, arguments);
      }

      return getFileUrl;
    }()
  }, {
    key: "getFileContents",
    value: function () {
      var _getFileContents = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(path, app, username, zoneFileLookupURL, forceText) {
        var fetchFn,
            opts,
            readUrl,
            response,
            contentType,
            etag,
            sessionData,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                fetchFn = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : createFetchFn();
                opts = {
                  app: app,
                  username: username,
                  zoneFileLookupURL: zoneFileLookupURL
                };
                _context5.next = 4;
                return this.getFileUrl(path, opts);

              case 4:
                readUrl = _context5.sent;
                _context5.next = 7;
                return fetchFn(readUrl);

              case 7:
                response = _context5.sent;

                if (response.ok) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 11;
                return getBlockstackErrorFromResponse(response, "getFile ".concat(path, " failed."), null);

              case 11:
                throw _context5.sent;

              case 12:
                contentType = response.headers.get('Content-Type');

                if (typeof contentType === 'string') {
                  contentType = contentType.toLowerCase();
                }

                etag = response.headers.get('ETag');

                if (etag) {
                  sessionData = this.userSession.store.getSessionData();
                  sessionData.etags[path] = etag;
                  this.userSession.store.setSessionData(sessionData);
                }

                if (!(forceText || contentType === null || contentType.startsWith('text') || contentType.startsWith('application/json'))) {
                  _context5.next = 20;
                  break;
                }

                return _context5.abrupt("return", response.text());

              case 20:
                return _context5.abrupt("return", response.arrayBuffer());

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getFileContents(_x12, _x13, _x14, _x15, _x16) {
        return _getFileContents.apply(this, arguments);
      }

      return getFileContents;
    }()
  }, {
    key: "getFileSignedUnencrypted",
    value: function () {
      var _getFileSignedUnencrypted = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(path, opt) {
        var sigPath, _ref, _ref2, fileContents, signatureContents, gaiaAddress, signature, publicKey, sigObject, signerAddress;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                sigPath = "".concat(path).concat(SIGNATURE_FILE_SUFFIX);
                _context6.prev = 1;
                _context6.next = 4;
                return Promise.all([this.getFileContents(path, opt.app, opt.username, opt.zoneFileLookupURL, false), this.getFileContents(sigPath, opt.app, opt.username, opt.zoneFileLookupURL, true), this.getGaiaAddress(opt.app, opt.username, opt.zoneFileLookupURL)]);

              case 4:
                _ref = _context6.sent;
                _ref2 = _slicedToArray(_ref, 3);
                fileContents = _ref2[0];
                signatureContents = _ref2[1];
                gaiaAddress = _ref2[2];

                if (fileContents) {
                  _context6.next = 11;
                  break;
                }

                return _context6.abrupt("return", fileContents);

              case 11:
                if (gaiaAddress) {
                  _context6.next = 13;
                  break;
                }

                throw new SignatureVerificationError("Failed to get gaia address for verification of: ".concat(path));

              case 13:
                if (!(!signatureContents || typeof signatureContents !== 'string')) {
                  _context6.next = 15;
                  break;
                }

                throw new SignatureVerificationError('Failed to obtain signature for file: ' + "".concat(path, " -- looked in ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

              case 15:
                _context6.prev = 15;
                sigObject = JSON.parse(signatureContents);
                signature = sigObject.signature;
                publicKey = sigObject.publicKey;
                _context6.next = 26;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t0 = _context6["catch"](15);

                if (!(_context6.t0 instanceof SyntaxError)) {
                  _context6.next = 25;
                  break;
                }

                throw new Error("Failed to parse signature content JSON (path: ".concat(path).concat(SIGNATURE_FILE_SUFFIX, ") The content may be corrupted."));

              case 25:
                throw _context6.t0;

              case 26:
                signerAddress = publicKeyToBtcAddress(publicKey);

                if (!(gaiaAddress !== signerAddress)) {
                  _context6.next = 29;
                  break;
                }

                throw new SignatureVerificationError("Signer pubkey address (".concat(signerAddress, ") doesn't match gaia address (").concat(gaiaAddress, ")"));

              case 29:
                if (verifyECDSA(typeof fileContents === 'string' ? utf8ToBytes(fileContents) : new Uint8Array(fileContents), publicKey, signature)) {
                  _context6.next = 31;
                  break;
                }

                throw new SignatureVerificationError("Contents do not match ECDSA signature: path: ".concat(path, ", signature: ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

              case 31:
                return _context6.abrupt("return", fileContents);

              case 34:
                _context6.prev = 34;
                _context6.t1 = _context6["catch"](1);

                if (!(_context6.t1 instanceof DoesNotExist && _context6.t1.message.indexOf(sigPath) >= 0)) {
                  _context6.next = 38;
                  break;
                }

                throw new SignatureVerificationError("Failed to obtain signature for file: ".concat(path, " -- looked in ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

              case 38:
                throw _context6.t1;

              case 39:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 34], [15, 21]]);
      }));

      function getFileSignedUnencrypted(_x17, _x18) {
        return _getFileSignedUnencrypted.apply(this, arguments);
      }

      return getFileSignedUnencrypted;
    }()
  }, {
    key: "handleSignedEncryptedContents",
    value: function () {
      var _handleSignedEncryptedContents = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(path, storedContents, app, privateKey, username, zoneFileLookupURL) {
        var appPrivateKey, appPublicKey, address, sigObject, signature, signerPublicKey, cipherText, signerAddress, decryptOpt;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                appPrivateKey = privateKey || this.userSession.loadUserData().appPrivateKey;
                appPublicKey = getPublicKeyFromPrivate(appPrivateKey);

                if (!username) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 5;
                return this.getGaiaAddress(app, username, zoneFileLookupURL);

              case 5:
                _context7.t0 = _context7.sent;
                _context7.next = 9;
                break;

              case 8:
                _context7.t0 = publicKeyToBtcAddress(appPublicKey);

              case 9:
                address = _context7.t0;

                if (address) {
                  _context7.next = 12;
                  break;
                }

                throw new SignatureVerificationError("Failed to get gaia address for verification of: ".concat(path));

              case 12:
                _context7.prev = 12;
                sigObject = JSON.parse(storedContents);
                _context7.next = 23;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t1 = _context7["catch"](12);

                if (!(_context7.t1 instanceof SyntaxError)) {
                  _context7.next = 22;
                  break;
                }

                throw new Error('Failed to parse encrypted, signed content JSON. The content may not be encrypted. If using getFile, try passing { verify: false, decrypt: false }.');

              case 22:
                throw _context7.t1;

              case 23:
                signature = sigObject.signature;
                signerPublicKey = sigObject.publicKey;
                cipherText = sigObject.cipherText;
                signerAddress = publicKeyToBtcAddress(signerPublicKey);

                if (!(!signerPublicKey || !cipherText || !signature)) {
                  _context7.next = 31;
                  break;
                }

                throw new SignatureVerificationError("Failed to get signature verification data from file: ".concat(path));

              case 31:
                if (!(signerAddress !== address)) {
                  _context7.next = 35;
                  break;
                }

                throw new SignatureVerificationError("Signer pubkey address (".concat(signerAddress, ") doesn't match gaia address (").concat(address, ")"));

              case 35:
                if (verifyECDSA(cipherText, signerPublicKey, signature)) {
                  _context7.next = 39;
                  break;
                }

                throw new SignatureVerificationError("Contents do not match ECDSA signature in file: ".concat(path));

              case 39:
                if (!(typeof privateKey === 'string')) {
                  _context7.next = 44;
                  break;
                }

                decryptOpt = {
                  privateKey: privateKey
                };
                return _context7.abrupt("return", this.userSession.decryptContent(cipherText, decryptOpt));

              case 44:
                return _context7.abrupt("return", this.userSession.decryptContent(cipherText));

              case 45:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[12, 16]]);
      }));

      function handleSignedEncryptedContents(_x19, _x20, _x21, _x22, _x23, _x24) {
        return _handleSignedEncryptedContents.apply(this, arguments);
      }

      return handleSignedEncryptedContents;
    }()
  }, {
    key: "putFile",
    value: function () {
      var _putFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(path, content, options) {
        var _this = this;

        var _a, _b, defaults, opt, gaiaHubConfig, maxUploadBytes, hasMaxUpload, contentLoader, contentType, sizeErrMsg, sizeErr, encryptedSize, _sizeErrMsg, _sizeErr, etag, newFile, sessionData, uploadFn, contentData, privateKey, signatureObject, signatureContent, contentForUpload, publicKey, _contentData, freshHubConfig;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                defaults = {
                  encrypt: true,
                  sign: false,
                  cipherTextEncoding: 'hex',
                  dangerouslyIgnoreEtag: false
                };
                opt = Object.assign({}, defaults, options);
                _context10.next = 4;
                return this.getOrSetLocalGaiaHubConnection();

              case 4:
                gaiaHubConfig = _context10.sent;
                maxUploadBytes = megabytesToBytes(gaiaHubConfig.max_file_upload_size_megabytes);
                hasMaxUpload = maxUploadBytes > 0;
                contentLoader = new FileContentLoader(content, opt.contentType);
                contentType = contentLoader.contentType;

                if (!(!opt.encrypt && hasMaxUpload && contentLoader.contentByteLength > maxUploadBytes)) {
                  _context10.next = 14;
                  break;
                }

                sizeErrMsg = "The max file upload size for this hub is ".concat(maxUploadBytes, " bytes, the given content is ").concat(contentLoader.contentByteLength, " bytes");
                sizeErr = new PayloadTooLargeError(sizeErrMsg, null, maxUploadBytes);
                console.error(sizeErr);
                throw sizeErr;

              case 14:
                if (!(opt.encrypt && hasMaxUpload)) {
                  _context10.next = 21;
                  break;
                }

                encryptedSize = eciesGetJsonStringLength({
                  contentLength: contentLoader.contentByteLength,
                  wasString: contentLoader.wasString,
                  sign: !!opt.sign,
                  cipherTextEncoding: opt.cipherTextEncoding
                });

                if (!(encryptedSize > maxUploadBytes)) {
                  _context10.next = 21;
                  break;
                }

                _sizeErrMsg = "The max file upload size for this hub is ".concat(maxUploadBytes, " bytes, the given content is ").concat(encryptedSize, " bytes after encryption");
                _sizeErr = new PayloadTooLargeError(_sizeErrMsg, null, maxUploadBytes);
                console.error(_sizeErr);
                throw _sizeErr;

              case 21:
                newFile = true;
                sessionData = this.userSession.store.getSessionData();

                if (!opt.dangerouslyIgnoreEtag) {
                  if ((_a = sessionData.etags) === null || _a === void 0 ? void 0 : _a[path]) {
                    newFile = false;
                    etag = (_b = sessionData.etags) === null || _b === void 0 ? void 0 : _b[path];
                  }
                }

                if (!(!opt.encrypt && opt.sign)) {
                  _context10.next = 34;
                  break;
                }

                _context10.next = 27;
                return contentLoader.load();

              case 27:
                contentData = _context10.sent;

                if (typeof opt.sign === 'string') {
                  privateKey = opt.sign;
                } else {
                  privateKey = this.userSession.loadUserData().appPrivateKey;
                }

                signatureObject = signECDSA(privateKey, contentData);
                signatureContent = JSON.stringify(signatureObject);

                uploadFn =
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee8(hubConfig) {
                    var writeResponse;
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _context8.next = 2;
                            return Promise.all([uploadToGaiaHub(path, contentData, hubConfig, contentType, newFile, etag, opt.dangerouslyIgnoreEtag), uploadToGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), signatureContent, hubConfig, 'application/json')]);

                          case 2:
                            writeResponse = _context8.sent[0];

                            if (!opt.dangerouslyIgnoreEtag && writeResponse.etag) {
                              sessionData.etags[path] = writeResponse.etag;

                              _this.userSession.store.setSessionData(sessionData);
                            }

                            return _context8.abrupt("return", writeResponse.publicURL);

                          case 5:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function uploadFn(_x28) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                _context10.next = 47;
                break;

              case 34:
                if (!(!opt.encrypt && !opt.sign)) {
                  _context10.next = 38;
                  break;
                }

                contentForUpload = contentLoader.content;
                _context10.next = 46;
                break;

              case 38:
                if (typeof opt.encrypt === 'string') {
                  publicKey = opt.encrypt;
                } else if (typeof opt.sign === 'string') {
                  publicKey = getPublicKeyFromPrivate(opt.sign);
                } else {
                  publicKey = getPublicKeyFromPrivate(this.userSession.loadUserData().appPrivateKey);
                }

                _context10.next = 41;
                return contentLoader.load();

              case 41:
                _contentData = _context10.sent;
                _context10.next = 44;
                return this.userSession.encryptContent(_contentData, {
                  publicKey: publicKey,
                  wasString: contentLoader.wasString,
                  cipherTextEncoding: opt.cipherTextEncoding,
                  sign: opt.sign
                });

              case 44:
                contentForUpload = _context10.sent;
                contentType = 'application/json';

              case 46:
                uploadFn =
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee9(hubConfig) {
                    var writeResponse;
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return uploadToGaiaHub(path, contentForUpload, hubConfig, contentType, newFile, etag, opt.dangerouslyIgnoreEtag);

                          case 2:
                            writeResponse = _context9.sent;

                            if (writeResponse.etag) {
                              sessionData.etags[path] = writeResponse.etag;

                              _this.userSession.store.setSessionData(sessionData);
                            }

                            return _context9.abrupt("return", writeResponse.publicURL);

                          case 5:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function uploadFn(_x29) {
                    return _ref4.apply(this, arguments);
                  };
                }();

              case 47:
                _context10.prev = 47;
                _context10.next = 50;
                return uploadFn(gaiaHubConfig);

              case 50:
                return _context10.abrupt("return", _context10.sent);

              case 53:
                _context10.prev = 53;
                _context10.t0 = _context10["catch"](47);

                if (!isRecoverableGaiaError(_context10.t0)) {
                  _context10.next = 66;
                  break;
                }

                console.error(_context10.t0);
                console.error('Possible recoverable error during Gaia upload, retrying...');
                _context10.next = 60;
                return this.setLocalGaiaHubConnection();

              case 60:
                freshHubConfig = _context10.sent;
                _context10.next = 63;
                return uploadFn(freshHubConfig);

              case 63:
                return _context10.abrupt("return", _context10.sent);

              case 66:
                throw _context10.t0;

              case 67:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[47, 53]]);
      }));

      function putFile(_x25, _x26, _x27) {
        return _putFile.apply(this, arguments);
      }

      return putFile;
    }()
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(path, options) {
        var gaiaHubConfig, opts, sessionData, freshHubConfig, _sessionData, _sessionData2, _freshHubConfig, _sessionData3;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.getOrSetLocalGaiaHubConnection();

              case 2:
                gaiaHubConfig = _context11.sent;
                opts = Object.assign({}, options);

                if (!opts.wasSigned) {
                  _context11.next = 29;
                  break;
                }

                _context11.prev = 5;
                _context11.next = 8;
                return deleteFromGaiaHub(path, gaiaHubConfig);

              case 8:
                _context11.next = 10;
                return deleteFromGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), gaiaHubConfig);

              case 10:
                sessionData = this.userSession.store.getSessionData();
                delete sessionData.etags[path];
                this.userSession.store.setSessionData(sessionData);
                _context11.next = 27;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](5);
                _context11.next = 19;
                return this.setLocalGaiaHubConnection();

              case 19:
                freshHubConfig = _context11.sent;
                _context11.next = 22;
                return deleteFromGaiaHub(path, freshHubConfig);

              case 22:
                _context11.next = 24;
                return deleteFromGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), gaiaHubConfig);

              case 24:
                _sessionData = this.userSession.store.getSessionData();
                delete _sessionData.etags[path];
                this.userSession.store.setSessionData(_sessionData);

              case 27:
                _context11.next = 47;
                break;

              case 29:
                _context11.prev = 29;
                _context11.next = 32;
                return deleteFromGaiaHub(path, gaiaHubConfig);

              case 32:
                _sessionData2 = this.userSession.store.getSessionData();
                delete _sessionData2.etags[path];
                this.userSession.store.setSessionData(_sessionData2);
                _context11.next = 47;
                break;

              case 37:
                _context11.prev = 37;
                _context11.t1 = _context11["catch"](29);
                _context11.next = 41;
                return this.setLocalGaiaHubConnection();

              case 41:
                _freshHubConfig = _context11.sent;
                _context11.next = 44;
                return deleteFromGaiaHub(path, _freshHubConfig);

              case 44:
                _sessionData3 = this.userSession.store.getSessionData();
                delete _sessionData3.etags[path];
                this.userSession.store.setSessionData(_sessionData3);

              case 47:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[5, 15], [29, 37]]);
      }));

      function deleteFile(_x30, _x31) {
        return _deleteFile.apply(this, arguments);
      }

      return deleteFile;
    }()
  }, {
    key: "getAppBucketUrl",
    value: function getAppBucketUrl(gaiaHubUrl, appPrivateKey) {
      return getBucketUrl(gaiaHubUrl, appPrivateKey);
    }
  }, {
    key: "listFilesLoop",
    value: function () {
      var _listFilesLoop = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(hubConfig, page, callCount, fileCount, callback) {
        var fetchFn,
            response,
            pageRequest,
            fetchOptions,
            freshHubConfig,
            responseText,
            responseJSON,
            entries,
            nextPage,
            entriesLength,
            i,
            rc,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                fetchFn = _args12.length > 5 && _args12[5] !== undefined ? _args12[5] : createFetchFn();

                if (!(callCount > 65536)) {
                  _context12.next = 3;
                  break;
                }

                throw new Error('Too many entries to list');

              case 3:
                _context12.t0 = hubConfig;

                if (_context12.t0) {
                  _context12.next = 8;
                  break;
                }

                _context12.next = 7;
                return this.getOrSetLocalGaiaHubConnection();

              case 7:
                _context12.t0 = _context12.sent;

              case 8:
                hubConfig = _context12.t0;
                _context12.prev = 9;
                pageRequest = JSON.stringify({
                  page: page
                });
                fetchOptions = {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Content-Length': "".concat(pageRequest.length),
                    Authorization: "bearer ".concat(hubConfig.token)
                  },
                  body: pageRequest
                };
                _context12.next = 14;
                return fetchFn("".concat(hubConfig.server, "/list-files/").concat(hubConfig.address), fetchOptions);

              case 14:
                response = _context12.sent;

                if (response.ok) {
                  _context12.next = 19;
                  break;
                }

                _context12.next = 18;
                return getBlockstackErrorFromResponse(response, 'ListFiles failed.', hubConfig);

              case 18:
                throw _context12.sent;

              case 19:
                _context12.next = 29;
                break;

              case 21:
                _context12.prev = 21;
                _context12.t1 = _context12["catch"](9);

                if (!(callCount === 0)) {
                  _context12.next = 28;
                  break;
                }

                _context12.next = 26;
                return this.setLocalGaiaHubConnection();

              case 26:
                freshHubConfig = _context12.sent;
                return _context12.abrupt("return", this.listFilesLoop(freshHubConfig, page, callCount + 1, 0, callback));

              case 28:
                throw _context12.t1;

              case 29:
                _context12.next = 31;
                return response.text();

              case 31:
                responseText = _context12.sent;
                responseJSON = JSON.parse(responseText);
                entries = responseJSON.entries;
                nextPage = responseJSON.page;

                if (!(entries === null || entries === undefined)) {
                  _context12.next = 37;
                  break;
                }

                throw new Error('Bad listFiles response: no entries');

              case 37:
                entriesLength = 0;
                i = 0;

              case 39:
                if (!(i < entries.length)) {
                  _context12.next = 48;
                  break;
                }

                if (!(entries[i] !== null)) {
                  _context12.next = 45;
                  break;
                }

                entriesLength++;
                rc = callback(entries[i]);

                if (rc) {
                  _context12.next = 45;
                  break;
                }

                return _context12.abrupt("return", fileCount + i);

              case 45:
                i++;
                _context12.next = 39;
                break;

              case 48:
                if (!(nextPage && entries.length > 0)) {
                  _context12.next = 52;
                  break;
                }

                return _context12.abrupt("return", this.listFilesLoop(hubConfig, nextPage, callCount + 1, fileCount + entriesLength, callback));

              case 52:
                return _context12.abrupt("return", fileCount + entriesLength);

              case 53:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[9, 21]]);
      }));

      function listFilesLoop(_x32, _x33, _x34, _x35, _x36) {
        return _listFilesLoop.apply(this, arguments);
      }

      return listFilesLoop;
    }()
  }, {
    key: "listFiles",
    value: function listFiles(callback) {
      return this.listFilesLoop(null, null, 0, 0, callback);
    }
  }, {
    key: "getOrSetLocalGaiaHubConnection",
    value: function () {
      var _getOrSetLocalGaiaHubConnection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        var sessionData, userData, hubConfig;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                sessionData = this.userSession.store.getSessionData();
                userData = sessionData.userData;

                if (userData) {
                  _context13.next = 4;
                  break;
                }

                throw new InvalidStateError('Missing userData');

              case 4:
                hubConfig = userData.gaiaHubConfig;

                if (!hubConfig) {
                  _context13.next = 7;
                  break;
                }

                return _context13.abrupt("return", Promise.resolve(hubConfig));

              case 7:
                return _context13.abrupt("return", this.setLocalGaiaHubConnection());

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getOrSetLocalGaiaHubConnection() {
        return _getOrSetLocalGaiaHubConnection.apply(this, arguments);
      }

      return getOrSetLocalGaiaHubConnection;
    }()
  }, {
    key: "setLocalGaiaHubConnection",
    value: function () {
      var _setLocalGaiaHubConnection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var userData, gaiaConfig, sessionData;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                userData = this.userSession.loadUserData();

                if (userData) {
                  _context14.next = 3;
                  break;
                }

                throw new InvalidStateError('Missing userData');

              case 3:
                if (!userData.hubUrl) {
                  userData.hubUrl = BLOCKSTACK_DEFAULT_GAIA_HUB_URL;
                }

                _context14.next = 6;
                return connectToGaiaHub(userData.hubUrl, userData.appPrivateKey, userData.gaiaAssociationToken);

              case 6:
                gaiaConfig = _context14.sent;
                userData.gaiaHubConfig = gaiaConfig;
                sessionData = this.userSession.store.getSessionData();
                sessionData.userData.gaiaHubConfig = gaiaConfig;
                this.userSession.store.setSessionData(sessionData);
                return _context14.abrupt("return", gaiaConfig);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setLocalGaiaHubConnection() {
        return _setLocalGaiaHubConnection.apply(this, arguments);
      }

      return setLocalGaiaHubConnection;
    }()
  }]);

  return Storage;
}();
export function getUserAppFileUrl(options) {
  return new Storage({}).getUserAppFileUrl(options.path, options.username, options.appOrigin, options.zoneFileLookupURL);
}

function normalizeOptions(userSession, options) {
  var _a;

  var opts = Object.assign({}, options);

  if (opts.username) {
    if (!opts.app) {
      if (!userSession.appConfig) {
        throw new InvalidStateError('Missing AppConfig');
      }

      opts.app = userSession.appConfig.appDomain;
    }

    if (!opts.zoneFileLookupURL) {
      if (!userSession.appConfig) {
        throw new InvalidStateError('Missing AppConfig');
      }

      if (!userSession.store) {
        throw new InvalidStateError('Missing store UserSession');
      }

      var sessionData = userSession.store.getSessionData();
      var configuredCoreNode = ((_a = sessionData.userData) === null || _a === void 0 ? void 0 : _a.coreNode) || userSession.appConfig.coreNode;

      if (configuredCoreNode) {
        opts.zoneFileLookupURL = "".concat(configuredCoreNode).concat(NAME_LOOKUP_PATH);
      }
    }
  }

  return opts;
}

function isRecoverableGaiaError(error) {
  if (!error || !error.hubError || !error.hubError.statusCode) {
    return false;
  }

  var statusCode = error.hubError.statusCode;

  if (statusCode === 401) {
    return true;
  }

  if (statusCode === 409) {
    return true;
  }

  if (statusCode >= 500 && statusCode <= 599) {
    return true;
  }

  return false;
}